import { render, staticRenderFns } from "./SeletorDePerfis.vue?vue&type=template&id=f0b5c80c"
import script from "./SeletorDePerfis.vue?vue&type=script&lang=ts"
export * from "./SeletorDePerfis.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports